import { createLifeArea as _createLifeArea } from '@griply/services';
import { NewLifeArea } from '@griply/types';
import { collection, doc, serverTimestamp, setDoc } from 'firebase/firestore';

import { getAuthentication, getDatabase } from './helpers';

export const createLifeArea = async (lifeArea: NewLifeArea) => {
  const user = (await getAuthentication()).currentUser;

  if (!user) {
    throw Error('unauthenticated');
  }

  const db = getDatabase();

  return _createLifeArea({
    lifeArea,
    userId: user.uid,
    collection,
    doc,
    setDoc,
    db,
    serverTimestamp,
  });
};
